var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.$store.state.layout === 'desktop')?_c('OrderDesktop'):_vm._e(),(_vm.$store.state.layout === 'mobile')?_c('OrderMobile'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }